import jspPlatformApi from "client/portals";

export const requestPasswordReset = async (email: string): Promise<void> => {
  await jspPlatformApi().authentication.postAuthPasswordResetRequest({
    body: { email },
  });
};

interface ResetPasswordParams {
  token: string;
  newPassword: string;
}

export const resetPassword = async ({
  token,
  newPassword,
}: ResetPasswordParams): Promise<void> => {
  await jspPlatformApi().authentication.postAuthPasswordResetConfirm({
    body: { token, new_password: newPassword },
  });
};
